# Русский язык
# Ключи читает генератор канвы CRM: crm-vue tool/gen-site-dictionary.mjs — правишь здесь, перегенерируй там.
app:
  title: "VINPROP - Недвижимость"
  home_title: "Недвижимость во Вьетнаме {'|'} Инвестиции {'|'} VINPROP"
common:
  view_all: "Смотреть все"
  send: "Отправить"
  cancel: "Отмена"
  ok: "OK"
  back: "Назад"
  retry: "Повторить"
  next: "Далее"
  scroll_prev: "Предыдущие"
  scroll_next: "Следующие"
  loading: "Загрузка..."
  error: "Ошибка"
  success: "Успешно"
  back_to_home: "Вернуться на главную"
  select: "Выбрать"
  selected: "Выбрано"
  error_with_message: "Ошибка: {message}"
  menu: "Меню"
  close: "Закрыть"
  # DEV-2334: номер страницы к H1 и <title> на /page/N — как PageTitleSuffix в SSR
  # (ssr internal/domain/services/template_labels.go). Генератор ssr этот ключ пока не берёт.
  page_title_suffix: " — Страница {page}"
header:
  # DEV-2334: H1 главной; SSR повторяет его генератором (ssr scripts/gen-site-texts).
  hero_text: "Недвижимость во Вьетнаме: новостройки и курортные проекты"
menu:
  projects_buy: "Купить недвижимость"
  residential_complexes: "Жилые комплексы"
  gated_communities: "Закрытые поселки"
  holiday_homes: "Курортная недвижимость"
  commercial_real_estate: "Коммерческая недвижимость"
  services: "Услуги"
  handbook: "Справочник по недвижимости"
  research_analytics: "Исследования и аналитика"
  news_blog: "Новости"
  agents: "Агентам"
  articles: "Статьи"
  articles_sub:
    buy_real_estate_vietnam: "Покупка недвижимости во Вьетнаме"
    analytics: "Аналитика рынка"
    investment: "Инвестиции"
  callback: "Обратный звонок"
  view_all: "Смотреть все"

breadcrumbs:
  home: "Главная"

search:
  project_type: "Тип проекта"
  location: "Местоположение"
  bedroom: "Количество комнат"
  min_price: "Минимальная цена USD"
  max_price: "Максимальная цена USD"
  search_button: "Поиск"
  price: "Цена"
  reset: "Сбросить"
  room_single: "комната"
  room_few: "комнаты"
  room_many: "комнат"
  project_types:
    residential_complex: "Жилой комплекс"
    gated_community: "Закрытый поселок"
    villa: "Вилла"
    holiday_homes: "Курортная недвижимость"
    commercial_real_estate: "Коммерческая недвижимость"
  rooms:
    one: "1 комната"
    many: "{count} комнаты"
    more: "5+ комнат"
  from_price: "от {price}"
  to_price: "до {price}"

# DEV-218: поиск ЖК по названию (лупа в шапке, поле в мобильном drawer)
rc_search:
  open: "Найти ЖК по названию"
  label: "Название ЖК"
  placeholder: "Название, застройщик, город"
  clear: "Очистить"
  close: "Закрыть поиск"
  results: "Подсказки"
  nothing_found: "Ничего не нашли по «{query}»"
  nothing_found_hint: "Проверьте написание или посмотрите весь каталог"
  unavailable: "Поиск временно недоступен"
  unavailable_hint: "Попробуйте позже или выберите проект в каталоге"
  catalog_link: "Смотреть все проекты"
  hint_choose: "выбрать"
  hint_open: "открыть"
  hint_close: "закрыть"

object_type:
  invalid: "Не указано"
  villa: "Вилла"
  condotel: "Кондотель"
  shophouse: "Шопхаус"
  apartment: "Апартаменты"
  studio: "Студия"
  penthouse: "Пентхаус"
  duplex: "Дуплекс"

amenities:
  invalid: "Не указано"
  bar: "Бар"
  restaurant: "Ресторан"
  spa: "Спа"
  yoga: "Йога"
  convenience_store: "Мини-маркет"
  shopping_mall: "Торговый центр"
  school: "Школа"
  kindergarten: "Детский сад"
  college: "Колледж"
  swimming_pool: "Бассейн"
  kids_playground: "Детская площадка"
  gym: "Тренажерный зал"
  community_room: "Общественная комната"
  jogging_path: "Беговая дорожка"
  bbq: "Барбекю"
  green_area: "Зеленая зона"
  tennis_court: "Теннисный корт"
  kids_pool: "Детский бассейн"
  parking: "Парковка"
  cafe: "Кафе"

countries:
  af: "Афганистан"
  al: "Албания"
  dz: "Алжир"
  ad: "Андорра"
  ao: "Ангола"
  ag: "Антигуа и Барбуда"
  ar: "Аргентина"
  am: "Армения"
  au: "Австралия"
  at: "Австрия"
  az: "Азербайджан"
  bs: "Багамы"
  bh: "Бахрейн"
  bd: "Бангладеш"
  bb: "Барбадос"
  by: "Беларусь"
  be: "Бельгия"
  bz: "Белиз"
  bj: "Бенин"
  bt: "Бутан"
  bo: "Боливия"
  ba: "Босния и Герцеговина"
  bw: "Ботсвана"
  br: "Бразилия"
  bn: "Бруней"
  bg: "Болгария"
  bf: "Буркина-Фасо"
  bi: "Бурунди"
  kh: "Камбоджа"
  cm: "Камерун"
  ca: "Канада"
  cv: "Кабо-Верде"
  cf: "ЦАР"
  td: "Чад"
  cl: "Чили"
  cn: "Китай"
  co: "Колумбия"
  km: "Коморы"
  cg: "Конго"
  cd: "ДР Конго"
  cr: "Коста-Рика"
  ci: "Кот-д'Ивуар"
  hr: "Хорватия"
  cu: "Куба"
  cy: "Кипр"
  cz: "Чехия"
  dk: "Дания"
  dj: "Джибути"
  dm: "Доминика"
  do: "Доминикана"
  ec: "Эквадор"
  eg: "Египет"
  sv: "Сальвадор"
  gq: "Экваториальная Гвинея"
  er: "Эритрея"
  ee: "Эстония"
  sz: "Эсватини"
  et: "Эфиопия"
  fj: "Фиджи"
  fi: "Финляндия"
  fr: "Франция"
  ga: "Габон"
  gm: "Гамбия"
  ge: "Грузия"
  de: "Германия"
  gh: "Гана"
  gr: "Греция"
  gd: "Гренада"
  gt: "Гватемала"
  gn: "Гвинея"
  gw: "Гвинея-Бисау"
  gy: "Гайана"
  ht: "Гаити"
  hn: "Гондурас"
  hk: "Гонконг"
  hu: "Венгрия"
  is: "Исландия"
  in: "Индия"
  id: "Индонезия"
  ir: "Иран"
  iq: "Ирак"
  ie: "Ирландия"
  il: "Израиль"
  it: "Италия"
  jm: "Ямайка"
  jp: "Япония"
  jo: "Иордания"
  kz: "Казахстан"
  ke: "Кения"
  ki: "Кирибати"
  kp: "КНДР"
  kr: "Южная Корея"
  kw: "Кувейт"
  kg: "Киргизия"
  la: "Лаос"
  lv: "Латвия"
  lb: "Ливан"
  ls: "Лесото"
  lr: "Либерия"
  ly: "Ливия"
  li: "Лихтенштейн"
  lt: "Литва"
  lu: "Люксембург"
  mo: "Макао"
  mg: "Мадагаскар"
  mw: "Малави"
  my: "Малайзия"
  mv: "Мальдивы"
  ml: "Мали"
  mt: "Мальта"
  mh: "Маршалловы Острова"
  mr: "Мавритания"
  mu: "Маврикий"
  mx: "Мексика"
  fm: "Микронезия"
  md: "Молдова"
  mc: "Монако"
  mn: "Монголия"
  me: "Черногория"
  ma: "Марокко"
  mz: "Мозамбик"
  mm: "Мьянма"
  na: "Намибия"
  nr: "Науру"
  np: "Непал"
  nl: "Нидерланды"
  nz: "Новая Зеландия"
  ni: "Никарагуа"
  ne: "Нигер"
  ng: "Нигерия"
  mk: "Северная Македония"
  no: "Норвегия"
  om: "Оман"
  pk: "Пакистан"
  pw: "Палау"
  ps: "Палестина"
  pa: "Панама"
  pg: "Папуа-Новая Гвинея"
  py: "Парагвай"
  pe: "Перу"
  ph: "Филиппины"
  pl: "Польша"
  pt: "Португалия"
  qa: "Катар"
  ro: "Румыния"
  ru: "Россия"
  rw: "Руанда"
  kn: "Сент-Китс и Невис"
  lc: "Сент-Люсия"
  vc: "Сент-Винсент и Гренадины"
  ws: "Самоа"
  sm: "Сан-Марино"
  st: "Сан-Томе и Принсипи"
  sa: "Саудовская Аравия"
  sn: "Сенегал"
  rs: "Сербия"
  sc: "Сейшелы"
  sl: "Сьерра-Леоне"
  sg: "Сингапур"
  sk: "Словакия"
  si: "Словения"
  sb: "Соломоновы Острова"
  so: "Сомали"
  za: "ЮАР"
  ss: "Южный Судан"
  es: "Испания"
  lk: "Шри-Ланка"
  sd: "Судан"
  sr: "Суринам"
  se: "Швеция"
  ch: "Швейцария"
  sy: "Сирия"
  tw: "Тайвань"
  tj: "Таджикистан"
  tz: "Танзания"
  th: "Таиланд"
  tl: "Восточный Тимор"
  tg: "Того"
  to: "Тонга"
  tt: "Тринидад и Тобаго"
  tn: "Тунис"
  tr: "Турция"
  tm: "Туркменистан"
  tv: "Тувалу"
  ug: "Уганда"
  ua: "Украина"
  ae: "ОАЭ"
  gb: "Великобритания"
  us: "США"
  uy: "Уругвай"
  uz: "Узбекистан"
  vu: "Вануату"
  va: "Ватикан"
  ve: "Венесуэла"
  vn: "Вьетнам"
  ye: "Йемен"
  zm: "Замбия"
  zw: "Зимбабве"

featured_listings:
  title: "Рекомендуемые жилые комплексы"
  urban_title: "Лучшие предложения городской недвижимости на {month} {year}"
  resort_title: "Лучшие предложения курортной недвижимости на {month} {year}"
  empty: "Нет рекомендуемых комплексов"
  months:
    1: "январь"
    2: "февраль"
    3: "март"
    4: "апрель"
    5: "май"
    6: "июнь"
    7: "июль"
    8: "август"
    9: "сентябрь"
    10: "октябрь"
    11: "ноябрь"
    12: "декабрь"

guides:
  title: "Справочник по недвижимости"
  coming_soon: "Этот раздел скоро появится. Следите за обновлениями!"
  market_guide: "Рынок недвижимости Вьетнама"
  legal_guide: "Юридическое руководство"
  pm_guide: "Руководство по управлению недвижимостью"
  buying_guide: "Руководство по покупке недвижимости"

articles:
  all_title: "Статьи"
  related_title: "Полезные статьи"
  empty: "Нет статей"
  count: "{count} статья | {count} статьи | {count} статей"
  type:
    news: "Новости"
    services: "Услуги"
    handbook: "Справочник"
    research_analytics: "Аналитика рынка"
    buy_guide: "Покупка недвижимости во Вьетнаме"
    investment: "Инвестиции"
    all: "Все статьи"
    default: "Статья"
  filtered_by_tag: "Статьи по тегу"
  page: "Страница"
  image_not_available: "Изображение недоступно"
  unknown_date: "Дата неизвестна"
  not_found: "Статья не найдена"
  go_back: "Вернуться к списку статей"
  property_guide:
    title: "Руководство по управлению недвижимостью во Вьетнаме"
    property_types: "Типы недвижимости"
    property_costs: "Стоимость недвижимости"
    legal_aspects: "Юридические аспекты"
    ownership_rules: "Правила владения"
    insurance_guidelines: "Рекомендации по страхованию"
    mortgages: "Ипотека во Вьетнаме"
    taxation_policies: "Налоговая политика"
  related_articles:
    title: "Похожие статьи"
    no_articles: "Нет похожих статей"
    error: "Ошибка загрузки статей"
  slider:
    aria_label: "Подборка объектов недвижимости"
    loading: "Загрузка подборки объектов"

form:
  title: "Заполните форму"
  subtitle: "Наши специалисты свяжутся с вами в ближайшее время"
  name: "Имя"
  name_placeholder: "Введите ваше имя"
  name_required: "Имя обязательно"
  phone: "Телефон"
  phone_placeholder: "+84 XXX XXX XXX"
  phone_required: "Телефон обязателен"
  phone_invalid: "Неверный формат телефона"
  city_optional: "Город (необязательно)"
  city_not_found: "Ничего не найдено — оставьте поле пустым"
  comment_optional: "Комментарий (необязательно)"
  city_interest: "Интересует город (необязательно)"
  city_interest_placeholder: "Начните вводить название"
  channel_legend: "Как удобнее связаться?"
  channel_whatsapp: "WhatsApp"
  channel_telegram: "Telegram"
  channel_phone: "Звонок"
  contact_whatsapp: "Телефон для WhatsApp"
  contact_phone: "Телефон для звонка"
  contact_telegram: "Telegram"
  telegram_placeholder: "{'@'}ник или номер телефона"
  telegram_hint: "Подойдёт и ник, и номер — распознаем сами"
  telegram_mode_nick: "Ввести ник"
  telegram_mode_phone: "Ввести номер"
  telegram_will_write: "Напишем в Telegram на {contact}"
  email: "Email"
  email_placeholder: "Введите ваш email"
  email_invalid: "Неверный формат email"
  comment: "Комментарий"
  comment_placeholder: "Введите ваш комментарий"
  message: "Сообщение"
  message_placeholder: "Расскажите о ваших пожеланиях..."
  submit: "Отправить"
  submit_error: "Ошибка отправки формы"
  success_title: "Спасибо за обращение!"
  success_message: "Мы получили вашу заявку и свяжемся с вами в ближайшее время"
  submit_another: "Отправить ещё одну заявку"
  privacy_note: "Нажимая кнопку, вы соглашаетесь с политикой конфиденциальности и обработкой персональных данных"

sidebar_form:
  agent_name_placeholder: "Александр Мелников"
  agent_role: "Менеджер по продажам"
  headline: "Подберём 3 лучших варианта под ваш бюджет"
  description: "с прогнозом доходности и сроками окупаемости"
  submit: "Получить персональный подбор"

validation:
  required_name: "Имя обязательно"
  required_phone: "Телефон обязателен"
  invalid_phone: "Введите корректный номер телефона"
  required_email: "Email обязателен"
  invalid_email: "Введите корректный email"
  invalid_telegram: "Ник от 4 символов — проверьте или введите номер"
  min_length: "Не короче {min} символов"

error:
  network: "Ошибка сети: {message}"
  server: "Ошибка сервера: {message}"
  form_submit: "Не удалось отправить форму. Пожалуйста, попробуйте позже."
  general: "Произошла ошибка"
  page_not_found: "Страница не найдена"
  page_not_found_description: "Извините, запрашиваемая страница не существует. Возможно, она была удалена или перемещена."

residential_complex:
  all_title: "Недвижимость"
  reset_filters: "Сбросить фильтры"
  no_complexes: "Нет жилых комплексов"
  more_details: "Подробнее"
  all_loaded: "Все комплексы загружены"
  not_found: "Жилой комплекс не найден"

complex_card:
  price_from: "от {price}"
  price_on_request: "Цена по запросу"
  details: "Подробнее"
  handover_date_not_specified: "Дата сдачи не указана"
  handover_completed: "Сдан"
  # DEV-2343: один формат срока сдачи на всех языках
  handover_quarter: "Q{quarter} {year}"
  from: "от"
  to: "до"
  sqm: "м²"
  area: "Площадь"
  price_range: "Диапазон цен"
  request_contacts: "Запросить контакт"
  apartments_available: "{count} квартир доступно"
  sold_out: "ПРОДАНО"
  # DEV-2299: тот же текст в crm-vue (превью) и ssr
  sales_start: "СТАРТ ПРОДАЖ {date}"
  studio: "Студия"
  delivery_in: "Сдача в"

complex_features:
  invalid: "Не указано"
  favorites: "В избранном"
  docs_checked: "Документы проверены"
  video_available: "Есть видео"
  handovered: "Сдано"
  pink_book_available: "Есть розовая книга"
  available_for_foreigners: "Доступно для иностранцев"

filters:
  title: "Фильтры"
  project_rank: "Класс проекта"
  amenities_title: "Удобства"
  features_title: "Особенности"
  rank:
    invalid: "Не указано"
    affordable: "Доступный"
    mid_end: "Средний"
    high_end: "Бизнес-класс"
    luxury: "Люкс"

complex_details:
  characteristics:
    due_date: "Срок сдачи"
    class: "Класс комплекса"
    altitude: "Высота"
    room_type: "Тип помещения"
    transport: "Транспортная доступность"
    info_not_available: "Информация недоступна"
  features:
    reputable_developer: "Надёжный застройщик"
    installment_plan: "Рассрочка платежа"
    full_legal_ground: "Полное юридическое основание"
    high_appreciation_potential: "Высокий потенциал оценки"
  class_type:
    high_end: "Бизнес-класс"
    mid_range: "Средний класс"
    economy: "Эконом-класс"
    luxury: "Премиум-класс"
    invalid: "Не указано"
  room_type:
    apartment: "Квартира"
    penthouse: "Пентхаус"
    duplex: "Дуплекс"
    studio: "Студия"
    invalid: "Не указано"
  developer_label: "Застройщик"
  handover_date_label: "Срок сдачи"
  project_class_label: "Класс проекта"
  complex_by_developer: "Жилой комплекс застройщика {name}"
  infrastructure: "Инфраструктура комплекса"
  construction_progress: "Ход строительства"
  construction_progress_description: "Фотографии с площадки строительства жилого комплекса"
  construction_progress_date: "Фотографии по состоянию на {date}"
  amenity_categories:
    establishment: "Заведения"
    for_children: "Для детей"
    sport: "Спорт"
    common_area: "Общие зоны"
  amenities:
    bar: "Бар"
    restaurant: "Ресторан"
    spa: "Спа"
    yoga: "Йога"
    convenience_store: "Мини-маркет"
    shopping_mall: "Торговый центр"
    school: "Школа"
    kindergarten: "Детский сад"
    college: "Колледж"
    swimming_pool: "Бассейн"
    kids_playground: "Детская площадка"
    gym: "Тренажерный зал"
    community_room: "Общественная комната"
    jogging_path: "Беговая дорожка"
    bbq: "Барбекю"
    green_area: "Зеленая зона"
    tennis_court: "Теннисный корт"
    kids_pool: "Детский бассейн"
    parking: "Парковка"
    cafe: "Кафе"
  documents:
    construction_permit: "Разрешение на строительство"
    land_use_right_certificate: "Сертификат права землепользования"
    bank_letter_of_guarantee: "Банковская гарантия"
    sale_permit: "Разрешение на продажу"
    sale_permit_for_foreigners: "Разрешение на продажу иностранцам"
  foreigners_heading: "Можно ли иностранцу купить недвижимость в {name}?"
  foreigners_yes: "Да, {name} продаётся иностранным покупателям."
  foreigners_permit: "У застройщика есть разрешение на продажу иностранцам — документ проверен юристами VINPROP."
  foreigners_pink_book: "По проекту выдаётся розовая книга — вьетнамский сертификат права собственности."
  foreigners_law: "По законодательству Вьетнама иностранцы могут владеть не более чем 30% квартир в одном доме; право собственности оформляется на 50 лет с возможностью продления."
  master_plan: "Генеральный план"
  about_project: "О проекте"
  location: "Расположение"
  finishing_options: "Варианты отделки"
  finishing_options_from: "Варианты отделки от {name}"
  about_developer: "О застройщике"
  documents_checking: "Проверка документов"
  other_complexes: "Другие комплексы застройщика"
  open_map: "Открыть карту"
  more_about_finishing: "Подробнее о вариантах отделки"
  go_to_developer_page: "Перейти на страницу застройщика"
  finishing_description: "Для квартир доступны различные варианты отделки"
  finishing_note: "Изображения представлены только для справки и могут отличаться от фактической отделки"
  developer_contacts: "Контакты застройщика"
  image_not_available: "Изображение недоступно"
  plan_not_available: "План недоступен"
  get_consultation: "Получить консультацию"
  price_range: "{min} - {max}"
  offers_available: "{count} акция доступна | {count} акции доступно | {count} акций доступно"
  contact_us: "Связаться с нами"
  contact_description: "Заполните форму ниже, и мы свяжемся с вами в ближайшее время"
  available_apartments_in: "Доступные квартиры в {name}"
  apartments_available: "Доступные квартиры"
  special_offers: "Специальные предложения"
  check_price_availability: "Уточняйте актуальные цены и наличие у менеджера"
  bedrooms_count: "{count} комнат"
  bedrooms: "{count} комнат"
  studio: "Студия"
  rooms_unspecified: "Комнатность не указана"
  units_available: "{count} доступно"
  buy_now: "Купить сейчас"
  more_detailed: "Подробнее"
  # DEV-1820: планировки и варианты отделки в раскрытой группе квартир.
  images:
    PROPERTY_IMAGE_TYPE_LAYOUT: "Планировка"
    PROPERTY_IMAGE_TYPE_FINISHING: "Варианты отделки"
  object_type: "Тип объекта"
  available_units: "Доступно"
  established: "Основан"
  total_projects: "Всего проектов"
  completed_projects: "Завершенных проектов"
  years_experience: "Лет опыта"
  visit_website: "Посетить сайт"
  contact_form_intro: "Заинтересованы в {name}? Оставьте заявку и наш менеджер свяжется с вами"
  benefit_consultation: "Бесплатная консультация специалиста"
  benefit_price: "Актуальные цены и спецпредложения"
  benefit_viewing: "Организация показа объекта"
  benefit_documents: "Помощь в проверке документов"
  full_address: "Полный адрес"
  district: "Район"
  city: "Город"
  loading_map: "Загрузка карты..."
  map_error: "Ошибка загрузки карты"
  map_placeholder: "Карта местоположения"
  open_in_google_maps: "Открыть в Google Maps"
  nearby_places: "Рядом находятся"
  meters: "м"
  photo_date: "Фото на {date}"
  total_photos: "Всего фотографий: {count}"
  last_update: "Последнее обновление: {date}"
  documents_verified: "Документы проверены"
  documents_description: "Все документы проекта прошли юридическую проверку нашими специалистами"
  document_verified: "Проверен"
  document_pending: "В обработке"
  documents_note: "Информация о документах обновляется регулярно. Для получения актуальных данных свяжитесь с менеджером."
  other_complexes_by: "Другие комплексы от {name}"
  view_details: "Посмотреть детали"
  no_other_complexes: "Других комплексов от этого застройщика пока нет"
  starting_price: "Цена от"

footer:
  contacts: "Контакты:"
  company_section: "Компания"
  legal_section: "Юридическая информация"
  about: "О нас"
  about_vinprop_title: "О VINPROP"
  about_snippet: "VINPROP — международная proptech-компания, специализирующаяся на рынке недвижимости Вьетнама. Мы объединяем технологические решения, аналитику и консалтинг для иностранных и локальных инвесторов. Предлагаем покупку квартир, вилл и коммерческой недвижимости в Хошимине, Ханое, Дананге и других городах Вьетнама."
  vn_company_name: "VINPROP REALTY VIETNAM LIMITED LIABILITY COMPANY"
  enterprise_code: "Код предприятия (налоговый номер)"
  projects_section: "Проекты/купить недвижимость"
  residential_complexes: "Жилые комплексы"
  gated_communities: "Закрытые поселки"
  holiday_homes: "Курортная недвижимость"
  commercial_real_estate: "Коммерческая недвижимость"
  services_section: "Услуги"
  advisory_services: "Инвестиционные консультации и сопровождение сделок"
  legal_consultation: "Юридические консультации"
  property_management: "Управление недвижимостью"
  fit_out: "Доукомплектация и меблировка"
  partners: "Для партнёров"
  legal_disclaimer: "Юридическая оговорка"
  terms_of_use: "Условия использования"
  careers: "Вакансии"
  privacy_policy: "Политика конфиденциальности"
  cookie_policy: "Политика cookie"
  handbook_section: "Справочник по недвижимости"
  buying_guide: "Руководство по покупке"
  legal_guide: "Юридическое руководство"
  pm_guide: "Руководство по управлению"
  market_guide: "Руководство по рынку недвижимости Вьетнама"
  developer_profiles: "Профили застройщиков"
  research_section: "Исследования и аналитика"
  news_blog: "Новости/блог"

cookie_consent:
  title: "Использование файлов cookie"
  description: "Мы используем файлы cookie для улучшения вашего опыта на нашем сайте, анализа посещаемости и персонализации контента. Вы можете настроить свои предпочтения или принять все cookies."
  customize: "Настроить"
  accept_all: "Принять все"
  reject_all: "Только необходимые"
  save_preferences: "Сохранить настройки"
  necessary: "Необходимые cookies"
  necessary_desc: "Эти cookies обеспечивают базовую функциональность сайта и не могут быть отключены."
  analytics: "Аналитические cookies"
  analytics_desc: "Помогают нам понять, как посетители взаимодействуют с сайтом, собирая анонимную статистику."
  marketing: "Маркетинговые cookies"
  marketing_desc: "Используются для показа релевантной рекламы и отслеживания эффективности рекламных кампаний."
  preferences: "Персонализационные cookies"
  preferences_desc: "Сохраняют ваши предпочтения (язык, тема и т.д.) для улучшения пользовательского опыта."
city_autocomplete:
  placeholder: "Начните вводить город…"
  min_chars: "Введите минимум 2 символа"
  loading: "Загрузка…"
  not_found: "Ничего не найдено"
  load_error: "Не удалось загрузить подсказки"
  retry: "Повторить"
  clear: "Очистить"
  manual_entry: "Указать вручную: «{query}»"
  manual_suffix: "(указан вручную)"
  back_to_search: "Вернуться к поиску по справочнику"

# DEV-1722: страница застройщика /developers/{slug}
# DEV-1719: две страницы города с разными интентами — листинг и гид.
city:
  # DEV-2334: {in_city} — city_in.<slug> или in_city ниже. SSR повторяет эти
  # строки генератором (ssr scripts/gen-site-texts) — правка требует перегенерации в ssr.
  catalog_title: "Квартиры и новостройки {in_city}"
  catalog_seo_title: "Купить квартиру {in_city}: новостройки и цены {'|'} VINPROP"
  # Фолбэк для города, которого нет в city_in
  in_city: "в городе {city}"
  guide_title: "{city}: гид для покупателя недвижимости"
  # DEV-1097: <title> вкладки. Не равен H1 — у SSR для него свой шаблон
  # (ssr/internal/domain/services/city_page.go, cityGuideFormats.Title),
  # и по одному URL заголовок обязан быть один. Правка seo_title города
  # из админки главнее шаблона — как и в SSR.
  guide_seo_title: "{city} — гид по городу: районы, цены, покупка недвижимости {'|'} VINPROP"
  guide_link: "О городе {city} →"
  catalog_link: "Все проекты города →"
  guide_crumb: "Гид по городу"
  projects_title: "Проекты в городе {city}"
  catalog_link_count: "Все проекты города ({count}) →"

# DEV-1758: хаб городов /locations. Тексты согласованы с SSR-хабом
# (ssr/internal/domain/services/city_page.go) — по одному адресу бот и человек
# видят одно и то же.
locations_hub:
  title: "Города Вьетнама"
  seo_title: "Города Вьетнама — гиды для покупателя недвижимости {'|'} VINPROP"
  intro: "Города Вьетнама, о которых на VINPROP есть гид: районы, инфраструктура, цены и правила покупки для иностранцев. У каждого города — проекты в продаже."
  empty: "Гиды по городам сейчас готовятся."
  all: "Все города"
  crumb: "Города"
  projects_count: "{count} проект | {count} проекта | {count} проектов"

# DEV-1762: хаб застройщиков /developers
developers_hub:
  title: "Застройщики Вьетнама"
  intro: "Компании, чьи проекты продаются на VINPROP. У каждой — описание и полный список жилых комплексов с ценами и сроками сдачи."
  empty: "Справочник застройщиков сейчас пуст."
  all: "Все застройщики"

developer:
  projects: "Проекты застройщика"
  no_projects: "Проектов этого застройщика сейчас нет в продаже."
  not_found: "Застройщик не найден"

# DEV-1808: hero главной — H1 живёт здесь, а не в шапке
home:
  hero:
    eyebrow: "VINPROP · Недвижимость Вьетнама"
    subtitle: "Жилые комплексы, виллы и курортные проекты в городах Вьетнама — с актуальными ценами и поддержкой на русском"
    all_cities: "Все города"
  stats:
    projects: "проект в каталоге | проекта в каталоге | проектов в каталоге"
    cities: "город | города | городов"
  # DEV-2334: SSR повторяет эти строки генератором (ssr scripts/gen-site-texts);
  # правка здесь требует перегенерации в ssr.
  intro:
    title: "Как купить недвижимость во Вьетнаме с VINPROP"
    p1: "Недвижимость во Вьетнаме, доступная иностранцу, — это прежде всего квартиры в новых жилых комплексах и курортные проекты у моря. В нашем каталоге собраны новостройки Вьетнама в Хошимине, Ханое, Хайфоне, Дананге, Нячанге, Вунгтау, на Фукуоке и в других городах. Крупные города обычно выбирают, чтобы жить или надолго сдавать квартиру, побережье — для отдыха и сдачи туристам. Купить квартиру в Нячанге, Дананге или Хошимине можно и на этапе строительства, и в уже сданном доме: у каждого проекта свои условия оплаты и срок сдачи."
    p2: "Можно ли иностранцу купить квартиру во Вьетнаме? Да: прежде всего коммерческое жильё (commercial housing), а также часть курортных проектов. На квартиру в жилом комплексе вы подписываете с застройщиком договор купли-продажи (SPA), а после сдачи дома получаете свидетельство о праве собственности — Pink Book. Иностранцу его выдают на 50 лет с правом один раз продлить ещё на 50. В одном доме (здании) жилого комплекса иностранцам может принадлежать не более 30 процентов квартир, поэтому остаток квоты проверяют до брони. На вторичном рынке иностранец покупает только у другого иностранца, а продать может любому покупателю. Социальное жильё иностранцам недоступно, а кондотели в курортных проектах оформляются как долгосрочная аренда, без Pink Book."
    p3: "Сама покупка идёт по понятной схеме. Вы выбираете проект и квартиру, бронируете её и вносите депозит. Это можно сделать издалека через агентство с вьетнамским счётом: вернуть депозит застройщик может только на счёт внутри страны. Договор купли-продажи жилья иностранец подписывает лично, находясь во Вьетнаме на законных основаниях. В той же поездке открывают личный счёт в местном банке. Расчёты с застройщиком идут только в донгах: вы переводите собственные средства на личный вьетнамский счёт и платите с него всю сумму сразу или в беспроцентную рассрочку на время стройки. После сдачи дома оформляют Pink Book и платят регистрационный сбор 0,5 процента."
    p4: "VINPROP нужен, чтобы на каждом шаге было ясно, что происходит и зачем. Мы подбираем проекты под вашу цель — жить, сдавать или вложиться надолго — и проверяем застройщика и документы: разрешения на строительство и продажу, право продавать квартиры иностранцам, остаток иностранной квоты, проект договора. Договор для иностранца составляется на вьетнамском и английском, и мы разбираем его с вами. Затем сопровождаем сделку от брони до Pink Book: депозит, приезд на подписание, открытие счёта, переводы в донгах. Всё это время с вами говорят по-русски."
    p5: "Почему Вьетнам? Экономика страны устойчиво растёт, сюда приходят иностранные инвестиции, города расширяются и строят инфраструктуру, а цены остаются относительно невысокими по сравнению с другими рынками Азии. Для собственника важно и другое: ежегодного налога на жильё нет, налоговые ставки одинаковы для иностранцев и граждан Вьетнама, а срок владения продлевается по государственной процедуре, без переговоров с хозяином земли. При этом рынок требует осторожности. Застройщики сильно различаются по надёжности, поэтому решение лучше принимать после проверки, а не по рекламным обещаниям доходности."
  faq:
    title: "Частые вопросы о покупке недвижимости во Вьетнаме"
    q1: "Может ли иностранец купить квартиру во Вьетнаме?"
    a1: "Да. Иностранец может купить коммерческое жильё (commercial housing) у застройщика или у другого иностранца и получить Pink Book — свидетельство о праве собственности. В одном доме (здании) жилого комплекса иностранцам может принадлежать не более 30 процентов квартир. Часть курортных проектов тоже доступна, но там оформляется долгосрочная аренда. Социальное жильё иностранцам не продаётся, а схемы с оформлением на гражданина Вьетнама мы не рекомендуем из-за юридических рисков."
    q2: "На какой срок иностранец владеет квартирой и можно ли его продлить?"
    a2: "Pink Book выдают иностранцу на 50 лет с даты оформления, и закон даёт право один раз продлить его ещё на 50 лет. Продление стоит 0,5 процента от первоначальной цены по договору, без привязки к рыночной стоимости. Если вы продаёте квартиру гражданину Вьетнама, новый владелец получает её в бессрочную собственность, поэтому оставшийся срок не мешает перепродаже."
    q3: "Какие налоги платят при покупке, владении и продаже недвижимости во Вьетнаме?"
    a3: "При покупке новостройки у застройщика платится НДС 10 процентов, обычно он уже включён в цену договора. При оформлении Pink Book добавляется регистрационный сбор 0,5 процента. Ежегодного налога на владение жильём во Вьетнаме нет. При продаже платится налог 2 процента от суммы сделки по договору, даже если квартира продаётся без прибыли. Ставки одинаковы для иностранцев и граждан Вьетнама."
    q4: "Нужно ли приезжать во Вьетнам лично и как оплачивать покупку?"
    a4: "Для жилой недвижимости — да: договор купли-продажи подписывают лично, находясь во Вьетнаме на законных основаниях. В той же поездке открывают личный счёт в местном банке, для этого нужны паспорт и виза на три месяца. Платят только в донгах: собственные средства вы переводите на личный вьетнамский счёт, а с него — застройщику. Депозит за бронь можно внести дистанционно через агентство, а договор аренды кондотеля подписать из-за рубежа."
    q5: "Помогает ли VINPROP с проверкой проекта и сделкой?"
    a5: "Да. Мы проверяем застройщика и его прошлые проекты, разрешения на строительство и продажу, допуск к продаже иностранцам и остаток квоты, разбираем с вами двуязычный договор. Затем сопровождаем сделку: бронь и депозит, приезд на подписание, открытие счёта, платежи в донгах и оформление Pink Book. Если видим риск, говорим о нём до подписания договора и основных платежей."

# DEV-2334: SSR повторяет эти строки генератором (ssr scripts/gen-site-texts);
# правка здесь требует перегенерации в ssr.
# H1, <title> и вводный текст каталогов /properties[/:type]; ключ раздела — слаг роута через «_».
catalog:
  h1:
    all: "Квартиры и новостройки во Вьетнаме"
    residential_complex: "Жилые комплексы во Вьетнаме"
    holiday_homes: "Курортная недвижимость во Вьетнаме"
    gated_community: "Закрытые посёлки во Вьетнаме"
    commercial: "Коммерческая недвижимость во Вьетнаме"
  title:
    all: "Купить квартиру во Вьетнаме: новостройки и цены {'|'} VINPROP"
    residential_complex: "Новостройки Вьетнама: квартиры в жилых комплексах {'|'} VINPROP"
    holiday_homes: "Кондотели и апартаменты у моря во Вьетнаме {'|'} VINPROP"
    gated_community: "Виллы и дома в закрытых посёлках Вьетнама {'|'} VINPROP"
    commercial: "Коммерческие помещения во Вьетнаме: каталог объектов {'|'} VINPROP"
  intro:
    all:
      p1: "Здесь собраны все проекты каталога: квартиры в жилых комплексах крупных городов и курортная недвижимость на побережье. Сузить выбор помогут фильтры по городу, цене и сроку сдачи. Сданный дом подойдёт, если квартира нужна сейчас, строящийся — если вы готовы подождать и платить по графику застройщика. На странице каждого проекта есть планировки и сроки сдачи."
      p2: "Прежде чем сравнивать цены, решите, какой формат вам нужен. Квартира в жилом комплексе оформляется в собственность с Pink Book, курортные апартаменты — по договору долгосрочной аренды, и правила у них разные. Если сомневаетесь, обратитесь к нам: VINPROP подберёт несколько подходящих вариантов, проверит застройщика и документы и сопроводит сделку до получения ключей и документов."
    residential_complex:
      p1: "В этом разделе — жилые комплексы, то есть коммерческое жильё (commercial housing), которое иностранец может оформить в собственность. После сдачи дома покупатель получает Pink Book на 50 лет с правом продления ещё на 50, а если продать квартиру гражданину Вьетнама, новый владелец получит её в бессрочную собственность. Для жилых проектов обязательна банковская гарантия застройщика на период строительства, у курортных её нет."
      p2: "Фильтры помогут выбрать город, бюджет и срок сдачи. Остаток иностранной квоты лучше уточнить заранее: в одном доме иностранцам может принадлежать не более 30 процентов квартир. В строящихся домах застройщики обычно предлагают беспроцентную рассрочку до сдачи. VINPROP проверит разрешения проекта и квоту и сопроводит сделку от брони до Pink Book."
    holiday_homes:
      p1: "Курортная недвижимость — это апартаменты и кондотели в туристических местах: на Фукуоке, в Нячанге, Дананге и других городах у моря. Юридически это иной формат, чем квартира в жилом комплексе: вместо Pink Book покупатель получает право пользования по договору долгосрочной аренды на оставшийся срок аренды земли застройщиком, обычно до 50 лет. Зато такой договор можно подписать из-за рубежа, не приезжая во Вьетнам."
      p2: "Спрос здесь держится на туризме, поэтому доход от аренды и возможность перепродажи зависят от потока гостей и работы управляющей компании; многие проекты работают с гостиничными операторами. Учтите, что на курортные проекты не распространяется обязательная банковская гарантия на период строительства, а застройщик вправе запросить полную оплату ещё до сдачи. Отфильтруйте варианты по городу, цене и сроку сдачи, а юридический статус проекта и застройщика поможет проверить VINPROP."

# DEV-2334: SSR повторяет эти строки генератором (ssr scripts/gen-site-texts);
# правка здесь требует перегенерации в ssr.
# «в Нячанге»: город с предлогом для city.catalog_*; ключ — слаг города через «_».
city_in:
  ho_chi_minh: "в Хошимине"
  hanoi: "в Ханое"
  da_nang: "в Дананге"
  nha_trang: "в Нячанге"
  vung_tau: "в Вунгтау"
  hai_phong: "в Хайфоне"
  hung_yen: "в Хынгйене"
  phu_quoc: "на Фукуоке"
  hue: "в Хюэ"
  quang_ninh: "в провинции Куангнинь"
  lao_cai: "в Лаокае"
  phan_thiet: "в Фантьете"
  quy_nhon: "в Куиньоне"
  tuyen_quang: "в Туенкуанге"
